<template>
    <div class="page  py-lg-6">
        <v-container :class="{'white px-0': phoneOnly}">
            <v-row :class="{'mx-0': phoneOnly}">
            
                <v-col cols="12" :class="{'pa-0': phoneOnly}">
                    <v-card class="pa-0 transparent" :class="{'bordered': pcOnly}" flat >
                        <v-card-text :class="{'px-0': phoneOnly}">
                                <template v-if="!loading || loadedOnce">
                                <v-list v-if="attachments && attachments.length" class="pa-0 transparent"> 
                                    <template v-for="(attachment, i) in attachments" >
                                        <v-list-item v-haptic :key="attachment.id" :href="attachment.url" download class="px-3 my-2 
                                       
                                        ">
                                            <div class="d-flex align-center pa-4">
                                                <v-icon color="strong-text">mdi-paperclip</v-icon>
                                            </div>
                                            <v-list-item-content>
                                                <v-list-item-title>{{attachment.name}}</v-list-item-title>
                                                <v-list-item-subtitle>
                                                    <v-chip dark :color="attachment.meta.extension === 'pdf' ? 'deep-orange' : 'primary'" label small class="me-1">
                                                        <v-icon class="me-1">mdi-file</v-icon>
                                                        {{attachment.meta.extension.toUpperCase()}}
                                                    </v-chip>
                                                    <v-chip label small class="ltr-dir">
                                                        {{attachment.size}}
                                                    </v-chip>
                                                </v-list-item-subtitle>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-btn as="a" icon color="primary" depressed @mousedown.stop @mouseover.stop @touchstart.stop @click.stop :href="attachment.url"
                                                :target="capRunning ? '_system' : '_self'"
                                                >
                                                <v-icon size="22">mdi-download</v-icon>
                                                </v-btn>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-divider inset v-if="i < attachments.length - 1" :key="'d' + i" style="border-color: rgba(0,0,0, 0.08)"></v-divider>
                                    </template>
                                </v-list>
                                <div v-else>
                                    <v-alert  outlined text type="info" color="blue-grey" :dense="phoneOnly" class="mb-0 mx-4 mx-lg-0">
                                        <div class="strong-text--text" :class="{'medium-text': phoneOnly}">
                                            لا توجد مذكرات
                                        </div>
                                    </v-alert>            
                                </div>
                                </template>
                        
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    name: "Attachments",
    data(){
        return {
            loading: true,
            loadedOnce: false,
        }
    },
    computed: {
        ...GlobalComputed,
        attachments(){
            return this.$store.state.attachmentsModule.attachments;
        },
     
    },

    methods: {
        ...GlobalMethods,
        getAttachments(initialLoad = false){
            if (!this.loading || initialLoad){
                this.loading = true;
                
                if (initialLoad){
                    this.setLinearLoading();
                }
                let data = {};
                this.$store.dispatch('getAttachments', {initialLoad, data}).then(()=>{
                    if (initialLoad){
                        this.setLinearLoading(false);
                        this.loadedOnce = true;
                    }
                    this.loading = false;

                }).catch((r)=>{
                    if (initialLoad){
                        this.setLinearLoading(false);
                    }
                    if (this.$route.name === 'attachments'){
                        this.showMsg('حدثت مشكلة أثناء تحميل المذكرات');
                    }
                    this.loading = false;
                });
            }
        },
      
    },
    mounted(){
        this.getAttachments(true);
        this.scrollToTop();
    }
};
</script>
